import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import { Button, DatePicker, Input, Modal, notification, Popconfirm, Radio, Table } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "../../styles/LeaveTabStyle.css";
import Constants from "../../utils/Constants";
import ShowMessage from "../common/alert/ShowMessage";
import DisplayName from "../common/DisplayName";

const {TextArea} = Input;
const {RangePicker} = DatePicker;

const WorkFromHomeLayout = ({archieved}) => {
    const [api, contextHolder] = notification.useNotification();
    const [dataSource, setDataSource] = useState([]);
    const [stat, setStat] = useState([]);
    const [wfhApplications, setWfhApplications] = useState([]);
    const [error, setError] = useState(null);
    const [halfDaySelection, setHalfDaySelection] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const [wfhFormData, setWfhFormData] = useState({
        wfh_from: "",
        wfh_to: "",
        wfh_reason: "",
    });
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [mealTypesForCancelation, setMealTypesForCancelation] = useState(Constants.MEAL_TYPE.FULL);

    const [searchText, setSearchText] = useState("");
    const [orderBy, setOrderBy] = useState("");
    const [applicationStatus, setApplicationStatus] = useState("");
    const [statusArray, setStatusArray] = useState([]);

    const [todayLeave, setTodayLeave] = useState([]);
    const [weeklyData, setWeeklyData] = useState([]);
    const [weeklyModalVisible, setWeeklyModalVisible] = useState(false);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 8
        },
    });
    const base_url = process.env.REACT_APP_BASE_URL;
    const clColor = {'0%': '#108ee9', '100%': '#108ee9'};
    const slColor = {'0%': '#87d068', '100%': '#87d068'};
    const rlColor = {'0%': '#C1482a', '100%': '#C1482a'};

    const getWfhProgressColor = (shortCode) => {
        if (shortCode === "CL") {
            return clColor;
        } else if (shortCode === "SL") {
            return slColor;
        } else {
            return rlColor;
        }
    }

    const openNotificationWithIcon = (type, message, description) => {
        api[type]({
            message,
            description,
            duration: 3
        });
    };

    const fetchWfhAllocations = async () => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            /*const response = await axios.get(
                `${base_url}/api/v1/client/wfh/allocations`,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            const wfhAllocations = response.data.data;
            const newData = response.data.data.map((item) => ({
                leave_type_id: item.leave_type_id,
                leave_type_name: item.leave_type_name,
                allocation_year: item.allocation_year,
                short_code: item.short_code,
                percentage: item.percentage,
                total_allocated_leaves_for_allocation_year:
                item.total_allocated_leaves_for_allocation_year,
                total_remaining_leaves_for_allocation_year:
                item.total_remaining_leaves_for_allocation_year,
            }));

            setDataSource(newData);
            setLeaveDataSource(leaveAllocations);
            if (leaveAllocations && leaveAllocations.length > 0) {
                setLeaveFormData({...leaveFormData, 'leave_type_id': leaveAllocations[0].leave_type_id});
            }*/
        } catch (error) {
            console.error("Error fetching WFH allocations:", error);
        }
    };

    const fetchWfhApplications = async () => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            let upcoming = 1;
            let apiUrl = `${base_url}/api/v1/client/wfh/applications`;
            let params = [];
            params.push(`search_text=${searchText}`);
            params.push(`order_by=${orderBy}`);
            params.push(`application_status=${applicationStatus}`);
            params.push(`upcoming=${upcoming}`);
            params.push(`page=${page}`);

            let actualUrl = apiUrl + (params.length > 0 ? "?" + params.join("&") : "");

            const response = await axios.get(
                actualUrl,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            const status = response.data.data.map((data) => ({
                currentStatus: data.current_status.map((status) => ({
                    managerName: status.manager_name,
                    status: status.status,
                    comment: status.comment,
                }))
            }));
            setStatusArray(status);
            setWfhApplications(response.data.data);
            setTotalPage(response.data.totalPages);
            setTableParams({
                pagination: {
                    current: page,
                    pageSize: 8,
                    total: response.data.totalWfhApplications
                },
            });
            setStat(response.data.statistics);
        } catch (error) {
            console.error("Error fetching WFH allocations:", error);
        }
    };

    const deleteWfhApplications = async (applicationId) => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            let apiUrl = `${base_url}/api/v1/client/wfh/applications/delete/${applicationId}`;

            await axios.delete(
                apiUrl,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );
            fetchWfhApplications()
            openNotificationWithIcon('success','SUCCESS', 'WFH application deleted successfully');
        } catch (error) {
            console.error("Error fetching WFH allocations:", error);
        }
    };

    const getWFHApplicationWeeklySummary = async () => {
        const accessToken = sessionStorage.getItem("accessToken");
        let response = await axios.get(
            `${base_url}/api/v1/client/wfh/applications/weekly/summary`,
            {
                headers: {Authorization: `Bearer ${accessToken}`},
            }
        );
        let {data} = response.data
        setTodayLeave(data[moment().format("YYYY-MM-DD")])
        setWeeklyData(formatData(data))
    }

    const formatData = (records) => {
        return Object.keys(records).map(item => {
            let record = records[item]
            return {
                key: item,
                date: <div style={{display: "flex", flexDirection: "column"}}>
                    <span>{item}</span>
                    <span>{moment(item).format("dddd")}</span>
                </div>,
                count: record.length,
                description: <div
                    style={{display: "flex", flexDirection: "column", marginBottom: "20px", fontSize: "12px"}}>
                    {record.map(i => (<DisplayName key={i.emp_code} item={i} showType={false}/>))}
                </div>
            }
        })
    }

    useEffect(() => {
        fetchWfhAllocations();
        getWFHApplicationWeeklySummary()
    }, []);

    useEffect(() => {
        fetchWfhApplications();
    }, [page])

    const showModal = () => {
        setWfhFormData({
            ...wfhFormData, wfh_reason: ""
        })
        if(false&&dataSource.length===0){
            setWarningMessage("You don't have any WFH allocation. Please contact Admin");
            setShowMessage(true);
        }
        else {
            setIsModalVisible(true);
            //setLeaveQuotes(LEAVE_QUOTES[Math.floor(Math.random() * LEAVE_QUOTES.length)]);
        }
    };

    const handleCancel = () => {
        setWarningMessage("")
        setIsModalVisible(false);
        setMealTypesForCancelation(Constants.MEAL_TYPE.FULL);
    };

    const handleCancelWithWarning = (message) => {
        setWarningMessage(message);
        setShowMessage(true);
    };

    const handleInputChange = (e) => {
        const {id, value} = e.target;
        setWfhFormData({...wfhFormData, [id]: value});
    };

    const handleMealCancelation = (value) => {

        if (value === "all") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.FULL);
        }
        if (value === "breakfast") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.BREAKFAST);
        }
        if (value === "lunch") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.LUNCH);
        }
        if (value === "none") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.NONE);
        }
    };

    const handleAddWFH = async () => {
        try {
            setIsModalVisible(false);
            const accessToken = sessionStorage.getItem("accessToken");
            const user_id = sessionStorage.getItem("userData");
            const reporting_manager = sessionStorage.getItem("reporting_manager");
            if(!reporting_manager||reporting_manager==='null'){
                setWarningMessage("You don't have any reporting manager associated. Please contact admin")
                setShowMessage(true)
                return;
            }

            if (!wfhFormData.wfh_from) {
                setError("Please select the WFH start date");
                return;
            }

            if (!wfhFormData.wfh_to) {
                setError("Please select the WFH end date");
                return;
            }

            if (!wfhFormData.wfh_reason) {
                setError("Please provide a WFH reason");
                return;
            }

            setError(null);

            // set meal cancelation for whole day for breakfast or lunch
            wfhFormData['cancel_meal_type'] = mealTypesForCancelation;

            let response = await axios.post(
                `${base_url}/api/v1/client/wfh/applications/create`,
                wfhFormData,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            if (response) {
                
                if(response?.data?.wfhAvailable === true) {

                    openNotificationWithIcon('success','SUCCESS', 'WFH application create success');

                    fetchWfhApplications();

                    setWfhFormData({
                        wfh_from: "",
                        wfh_to: "",
                        wfh_reason: ""
                    });

                    handleCancel();

                } else {

                    openNotificationWithIcon('error','ERROR', 'WFH application create failed');

                    handleCancelWithWarning(response?.data?.msg);

                }
            }
            else {
                openNotificationWithIcon('error','ERROR', 'WFH application create failed');
            }

        } catch (error) {

            console.error("Error adding leave:", error);

        }
    };

    let columns = [
        {
            title: "Applicant",
            dataIndex: "leave_type_name",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column", whiteSpace: "nowrap"}}>
                    <div>
                        <div style={{fontSize: "12px"}} dangerouslySetInnerHTML={{__html: `Asked for a <b>WFH</b>`}}></div>
                    </div>
                </div>
            )
        },
        {
            title: "Reason",
            dataIndex: "leave_reason",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{fontSize: "12px"}} dangerouslySetInnerHTML={{__html: `${record.wfh_reason}`}}></div>
                </div>
            )
        },
        {
            title: "Details",
            dataIndex: "leave_length",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column", whiteSpace: "nowrap"}}>
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <PlayCircleOutlineOutlinedIcon style={{fontSize: "medium", color: "green"}} />
                            <span style={{paddingLeft: "5px"}}> <b>{record.wfh_from} ( {record.wfh_from_day} )</b></span>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <StopCircleOutlinedIcon style={{fontSize: "medium", color: "red"}} />
                            <span style={{paddingLeft: "5px"}}> <b>{record.wfh_to} ( {record.wfh_to_day} )</b></span>
                        </div>
                    </div>
                    {record.total_requested_days_including_holidays!==record.total_requested_days_excluding_holidays?(
                        <>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium", color: "#6b9f6b"}} />
                                <span style={{paddingLeft: "5px"}}> <b>{record.total_requested_days_including_holidays} day(s)</b> including holidays</span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium", color: "#6b9f6b"}} />
                                <span style={{paddingLeft: "5px"}}> <b>{record.total_requested_days_excluding_holidays} day(s)</b> excluding holidays</span>
                            </div>
                        </>
                    ): (
                        <>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium"}} />
                                <span style={{paddingLeft: "5px"}}><b>{record.total_requested_days_including_holidays} day(s)</b> Only</span>
                            </div>
                        </>
                    )}
                </div>
            )
        },
        {
            title: "Status",
            dataIndex: "final_status",
            render: (_, record) => (
                <div style={getStatusBadge(record.final_status)}
                     className="application-status" dangerouslySetInnerHTML={{__html: `${record.final_status}`}}></div>
            )
        },
        {
            title: "Approvals",
            dataIndex: "current_status",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column"}}>
                    {record.current_status && record.current_status.length > 0 ? (
                        <div className="list-item-col">
                            {record.current_status.map((i, index) => (
                                <div className="table-item-row item-padding" key={index}>
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div style={{
                                            width: "20px",
                                            textAlign: "center"
                                        }}>{`${index + 1}.`}</div>
                                        <div style={{width: "150px"}}>{`${i.manager_name}`}</div>
                                        <div style={{width: "100px"}}>
                                            <div style={getStatusBadge(i.status)}
                                                 className="user-status">{`${i.status}`}</div>
                                        </div>
                                    </div>
                                    <div style={{
                                        marginLeft: "20px",
                                        fontSize: "12px"
                                    }}>{`${i.comment === '' ? 'Waiting for feedback' : i.comment}`}</div>
                                </div>
                            ))}
                        </div>
                    ) : ""
                    }
                </div>
            )
        },
        {
            title: "Action",
            dataIndex: "action",
            hidden: true,
            render: (_, record) => (
                <div>
                    {record.final_status==='Pending'?(
                        <Popconfirm
                            title="Warning"
                            description="Are you sure want to cancel?"
                            onConfirm={() => onDeleteApplication(record.wfh_application_id)}
                            onCancel={() => {
                            }}
                            okText="Yes"
                            cancelText="No"
                        >
                            <div className="action-btn delete-btn">Cancel</div>
                        </Popconfirm>
                    ):""}
                </div>
            )
        }
    ];

    function getLeaveTextColor(shortCode) {
        if (shortCode === "CL") {
            return {color: "#108ee9", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        } else if (shortCode === "SL") {
            return {color: "#87d068", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        } else {
            return {color: "#C1482a", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        }
    }

    function getStatusBadge(status) {
        if (status === "Pending") {
            return {background: "#FFC300"};
        } else if (status === "Approved") {
            return {background: "#87d068"};
        } else if (status === "Rejected") {
            return {background: "#C70039", color: "#FFFFFF"};
        }
    }

    const onRangeSet = (value) => {
        if (value?.length > 0) {
            let startDate = value[0].format("YYYY-MM-DD");
            let endDate = value[1].format("YYYY-MM-DD");
            let object = {...wfhFormData, 'wfh_from': startDate, 'wfh_to': endDate}
            setWfhFormData(object);
        }
    }

    useEffect(() => {
        if (wfhFormData.leave_to && wfhFormData.leave_from && wfhFormData.leave_to === wfhFormData.leave_from) {
            setHalfDaySelection(true)
        } else {
            setHalfDaySelection(false)
        }
    }, [wfhFormData])

    const onPageChange = (selectedPage) => {
        setPage(selectedPage.current)
        setTableParams({
            selectedPage
        });
    }

    const onDeleteApplication = (applicationId) => {
        deleteWfhApplications(applicationId)
    }

    function onWarningClick(){
        setShowMessage(false)
    }

    const disableDates = (current) => {
        const today = moment().add(-1, "days");
        return current.isBefore(today);
    }

    const onWeeklyModalClose = () => {
        setWeeklyModalVisible(false)
    }

    const weeklyColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Count(s)',
            dataIndex: 'count',
            key: 'count',
        }
    ];

    return (
        <>
            <div className="leave-container">
                {contextHolder}
                <div className="summary-info" onClick={() => setWeeklyModalVisible(true)}>
                    <div style={{fontWeight: "bold", marginRight: "5px"}}>Today in WFH:</div>
                    {todayLeave && todayLeave.length > 0 ? (<div>
                        {todayLeave.map(item => (<DisplayName key={item.emp_code} item={item} showType={false}/>))}
                    </div>) : (<div style={{marginRight: "5px"}}>Nobody has taken WFH</div>)}
                </div>
                <div style={{display: "flex", flexDirection: "column"}} className='leave-info'>
                    <div className="leave-action-section">
                        <Button type="primary" onClick={showModal}>
                            Apply WFH
                        </Button>
                    </div>
                </div>
                <ShowMessage title="Warning" message={warningMessage} show={showMessage} onClickOk={onWarningClick}/>
                <Modal
                    title="WFH Application"
                    centered
                    open={isModalVisible}
                    onOk={handleAddWFH}
                    onCancel={handleCancel}
                    destroyOnClose={true}
                >
                    <hr/>
                    <div style={{marginBottom: "10px", display: "flex", flexDirection: "column"}}>
                        <label htmlFor="leave_from" style={{marginBottom: "5px"}}>
                            WFH Dates:
                        </label>
                        <RangePicker disabledDate={disableDates} onChange={onRangeSet} format="YYYY-MM-DD"/>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="wfh_reason" style={{marginBottom: "5px"}}>
                            WFH Reason:
                        </label>
                        <TextArea
                            id="wfh_reason"
                            value={wfhFormData.wfh_reason}
                            onChange={handleInputChange}
                            rows={3}
                            required
                            style={{width: "100%"}} // Adjust the width as needed
                        />
                    </div>
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="cancel_meal_type" style={{marginBottom: "5px", color: "#9f6c20"}}>
                            Remember! Your ordered meals will cancel at the time you apply WFH.
                        </label>
                        <Radio.Group
                            id='cancel_meal_type'
                            defaultValue={"all"}
                            style={{
                                padding: "4px 0px",
                                border: "1px solid rgb(204 204 204 / 50%)",
                                borderRadius: "7px",
                                width: "100%",
                            }}
                        >
                            <Radio className='rd-meal-type' value="all" onClick={() => handleMealCancelation("all")} defaultChecked={true}>
                                All
                            </Radio>
                            <Radio className='rd-meal-type' value="breakfast" onClick={() => handleMealCancelation("breakfast")}>
                                Breakfast
                            </Radio>
                            <Radio className='rd-meal-type' value="lunch" onClick={() => handleMealCancelation("lunch")}>
                                Lunch
                            </Radio>
                            <Radio className='rd-meal-type' value="none"  onClick={() => handleMealCancelation("none")}>
                                None
                            </Radio>
                        </Radio.Group>
                    </div>
                    {error && (
                        <div style={{color: "red", marginBottom: "10px"}}>{error}</div>
                    )}
                </Modal>
                <Modal
                    title="Weekly WFH Summary"
                    centered
                    open={weeklyModalVisible}
                    onOk={onWeeklyModalClose}
                    onCancel={onWeeklyModalClose}
                    cancelButtonProps={{style: {display: 'none'}}}
                    destroyOnClose={true}
                >
                    <div style={{marginBottom: "10px"}}>
                        <Table
                            columns={weeklyColumns}
                            pagination={false}
                            expandable={{
                                expandedRowRender: (record) => (
                                    <p
                                        style={{
                                            margin: 0,
                                        }}
                                    >
                                        {record.description}
                                    </p>
                                ),
                                rowExpandable: (record) => record.count !== 0,
                            }}
                            dataSource={weeklyData}
                        />
                    </div>

                </Modal>
                <div
                    style={{
                        margin: "40px 0px",
                        padding: "10px 0px",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <div className="list-title">All requested WFH</div>
                    <Table
                        columns={columns}
                        dataSource={wfhApplications}
                        pagination={tableParams.pagination}
                        onChange={onPageChange}
                        rowKey={(record) => record.wfh_application_id}
                        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                    />
                </div>
            </div>
        </>
    );
};

export default WorkFromHomeLayout;
